// import { TrackingEvent } from '@src/adobe-launch/types';
import { jsBridge } from '@src/utils/js-bridge';
import { removeCIDUrl } from '@src/utils/util';
import { useRouter } from 'next/router';
import { useCallback, useEffect } from 'react';

export function useLinkHandlers(scope: HTMLElement | null) {
    const router = useRouter();
    const handleInAppLinkClick = useCallback(
        (link: HTMLElement, dataHref: string | null) => {
            if (dataHref) {
                let pathname = dataHref;
                if (!pathname.startsWith('/')) {
                    pathname = '/' + pathname;
                }
                router.push(removeCIDUrl(`${pathname}${location.search}`), undefined);
            }
        },
        [router]
    );

    const handleExternalLinkClick = useCallback((link: HTMLElement, dataHref: string | null) => {
        const href = dataHref?.trim();
        if (href && href != '#') {
            jsBridge.appOpenExternalBrowser(href);
            // adobeDataLayer?.push({
            //     event: 'non-pageview',
            //     interaction: { eventID: TrackingEvent.CallToAction },
            // });
        }
    }, []);

    useCustomHandlerForLinks(scope, '.inAppLink', handleInAppLinkClick);
    useCustomHandlerForLinks(scope, '.externalLink', handleExternalLinkClick);
}

export function useCustomHandlerForLinks(
    scope: HTMLElement | null,
    selector: string,
    onclick: (link: HTMLElement, dataHref: string | null, evt?: Event) => void
) {
    const handleClick = useCallback(
        (evt: Event) => {
            const ele = evt.currentTarget as HTMLElement;
            const dataHref = ele.getAttribute('data-href');
            onclick(ele, dataHref, evt);
        },
        [onclick]
    );
    useEffect(() => {
        if (scope) {
            const links = scope.querySelectorAll(selector);
            links.forEach((link) => {
                let dataHref = link.getAttribute('data-href');
                if (!dataHref) {
                    const href = link.getAttribute('href');
                    if (href != null) {
                        dataHref = href;
                        link.setAttribute('data-href', dataHref);
                        link.removeAttribute('href');
                    }
                }
                link.addEventListener('click', handleClick);
            });
            return () => {
                links.forEach((link) => link.removeEventListener('click', handleClick));
            };
        }
    }, [handleClick, scope, selector]);
}
